// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#fb-root .fb_dialog{visibility:hidden!important}html[dir=ltr] #fb-root iframe[kwframeid=\"2\"]{bottom:10pt!important;right:50pt!important}html[dir=rtl] #fb-root iframe[kwframeid=\"2\"]{bottom:10pt!important;left:50pt!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
